<template>
  <div class="translationCorpusDialohg">
    <el-dialog :close-on-click-modal="false" :show-close="false"
               :visible.sync="translationCorpusVisible" custom-class="translationCorpus"
               :before-close="handlerClose">
      <template slot="title">
        <DialogsHeader
                       :title="dialogType==='memory'?$t('intelligentTranslation.Memorysettings'):$t('intelligentTranslation.TermSettings')" />
      </template>
      <div class="content">
        <div class="setmount">
          <div class="setmount-l">
            {{$t('newProjectV2.mounted')}}：<em>{{mountNum}}</em>
          </div>
          <div class="setmount-r">
            <el-button @click="handlermount">{{$t('newProjectV2.mount')}}</el-button>
            <el-button @click="handlerCloseAll">{{$t('newProjectV2.cancelAll')}}</el-button>
          </div>
        </div>
        <div class="table-box">
          <el-table class="tabBox" border :data="dataList" @selection-change="selectionchange"
                    ref="tableData">
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column type="index" :label="$t('projectV2.index')" width="60" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('memoryBankV2.bankName')" align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column prop="langDesc" :label="$t('projectV2.langDesc')" align="center"
                             :show-overflow-tooltip="true">
              <template
                        slot-scope="{ row }">{{$i18n.locale === 'zh' ? row.langDesc.replace('>'," — ") : $langCase[row.sourceLang] + ' — ' + $langCase[row.targetLang]}}</template>
            </el-table-column>
            <el-table-column prop="domainName" :label="$t('projectV2.domain')" align="center">
              <template
                        slot-scope="{ row }">{{$i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode]}}</template>
            </el-table-column>
            <el-table-column prop="sentCount" :label="$t('newProjectV2.sentNum')" align="center"
                             :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column :label="$t('newProjectV2.mount')" min-width="40" align="center"
                             class-name="operation">
              <template slot-scope="{row}">
                <el-switch v-model="row.switch" active-color="#13ce66" inactive-color="#E6E6E6"
                           @change="changeSwitch">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer-top" v-if="false">
          {{$t('intelligentTranslation.threshold')}} <el-select v-model="mountInfo.threshold"
                     :placeholder="$t('project.pleaseChoose')">
            <el-option v-for="item in thresholdOption" :key="item.value" :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="footer-bottom">
          <el-button @click="handlerClose">{{$t('termBankV2.cancel')}}</el-button>
          <el-button v-preventReClick type="primary" @click="handlerdetermine">
            {{$t('projectDetailsV2.save')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 标题组件
import DialogsHeader from '@/common/dialogsHeader';
import {
  querySelectableTermMemoryList
} from '@/services/newProjectApi';
export default {
  name: "translationCorpusDialog",
  data() {
    return {
      mountNum: 0,
      dataList: [],
      mountInfo: {
        memoryIdList: [],
        termIdList: [],
        threshold: 50,
      },
      selectList: [],//勾选的集合
      thresholdOption: [
        {
          label: "50%",
          value: 50,
        },
        {
          label: "70%",
          value: 70,
        },
        {
          label: "90%",
          value: 90,
        }
      ],
    }
  },
  props: {
    translationCorpusVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      requried: true
    },

  },
  components: { DialogsHeader },
  methods: {
    changeSwitch() {
      this.getSelectList();
    },
    handlerClose() {
      this.$emit('handlerClose')
    },
    handlerdetermine() {
      let arr = this.dataList.filter(item => item.switch);
      if (this.dialogType === 'memory') {
        this.mountInfo.memoryIdList = arr.map(item => item.id);
      } else {
        this.mountInfo.termIdList = arr.map(item => item.id);
      }
      this.$emit('handlerdetermine', this.mountInfo);
    },
    handlermount() {
      if (this.selectList.length === 0) {
        if (this.dialogType === 'memory') {
          this.$message.closeAll();
          this.$message.warning(this.$t('newProjectV2.selMemoryBankTip'));
          return
        } else {
          this.$message.closeAll();
          this.$message.warning(this.$t('newProjectV2.selTermBankTip'));
          return
        }
      }
      this.selectList.forEach(item => {
        this.$set(item, 'switch', true)
      })
      this.getSelectList();
      this.$refs['tableData'].clearSelection();
    },
    getSelectList() {
      let arr = this.dataList.filter(item => item.switch);
      if (this.dialogType === 'memory') {
        this.mountInfo.memoryIdList = arr.map(item => item.id);
        this.mountNum = this.mountInfo.memoryIdList.length;
      } else {
        this.mountInfo.termIdList = arr.map(item => item.id);
        this.mountNum = this.mountInfo.termIdList.length;
      }
    },
    selectionchange(select) {
      this.selectList = select;
    },
    //获取挂在记忆库术语库
    async getSelectableTermMemoryList(langInfo, type, mountInfo) {
      const { result, success } = await querySelectableTermMemoryList(langInfo)
      if (success) {
        if (type === 'memory') {
          result.transMemoryLibList.forEach(item => {
            if (!(mountInfo.memoryIdList)) {
              this.$set(item, 'switch', false)
              return
            }
            mountInfo.memoryIdList.forEach(child => {
              if (item.id === child) {
                this.$set(item, 'switch', true)
              }
            })
          })
          this.dataList = result.transMemoryLibList
        } else {
          result.transTermLibList
            .forEach(item => {
              if (!(mountInfo.termIdList)) {
                this.$set(item, 'switch', false)
                return
              }
              mountInfo.termIdList.forEach(child => {
                if (item.id === child) {
                  this.$set(item, 'switch', true)
                }
              })
            })
          this.dataList = result.transTermLibList
        }
        this.getSelectList();
      }
    },
    handlerCloseAll() {
      this.$refs['tableData'].clearSelection();
      this.dataList.forEach(item => {
        this.$set(item, 'switch', false)
      })
      this.getSelectList();
    }
  }
}
</script>
<style lang="less"  scoped>
.translationCorpusDialohg {
  @media (max-width: 1280px) {
    /deep/.el-dialog {
      width: 800px !important;
      height: 500px !important;
      .table-box {
        .el-table {
          height: 282px !important;
        }
      }
    }
  }
  /deep/.translationCorpus {
    width: 1272px;
    height: 730px;
    border-radius: 4px 4px 4px 4px;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0px;
    margin-top: 0px !important;
    .el-dialog__header {
      padding: 16px 32px 0px 32px;
    }
    .el-dialog__body {
      padding: 14px 32px 0px 32px;
      .content {
        .setmount {
          display: flex;
          justify-content: space-between;
          .setmount-l {
            font-size: 14px;
            font-weight: 400;
            font-family: PingFang SC-Regular, PingFang SC;
            em {
              color: #0078fc;
            }
          }
          .setmount-r {
            .el-button {
              padding: 7px 24px;
              border-color: #0078fc;
              color: #0078fc;
              height: 32px;
            }
          }
        }
        .table-box {
          margin-top: 16px;
          .el-table {
            height: 506px;
            overflow-y: auto;
            border-radius: 4px;
            .el-table__header th {
              padding: 0;
              height: 48px;
              font-size: 14px;
              font-weight: bold;
              color: #566087;
              background: #e4edfc;
              &:first-child .cell {
                padding-right: 14px;
              }
            }
            .el-table__body td {
              padding: 8px 0;
              height: 45px;
            }
            &:before {
              display: none;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      padding: 15px 32px;
      .dialog-footer {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        .footer-top {
          display: flex;
          width: 100%;
          justify-content: flex-start;
          .el-select {
            width: 99px;
            height: 32px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            margin-left: 13px;
            .el-input__inner {
              height: 32px;
            }
          }
        }
        .footer-bottom {
          width: 100%;
          display: flex;
          justify-content: center;
          .el-button {
            padding: 7px 24px;
            height: 32px;
          }
          .el-button + .el-button {
            margin-left: 20px;
          }
          .el-button--default {
            border-color: #0078fc;
            color: #0078fc;
          }
        }
      }
    }
  }
}
</style>